export default __webpack_public_path__ + "static/image-social-proof-886825d575b29c80a24f43223993033a.png";